import idsEqual from './idsEqual';

export const MENTIONS_REVISION_TYPES = [
  'asset.revision.approved',
  'asset.revision.disapproved',
  'asset.revision.created',
];

export default function isMentionsNotification(event, userId) {
  if (!event || !event.type) {
    return false;
  }
  if (event.type === 'asset.comment.added') {
    const mentions = event.data?.comment?.mentions || [];
    return mentions.some((mention) => idsEqual(mention?._id, userId));
  }
  if (event.type === 'assets.assigned') {
    const assignees = event.data?.assignees || [];
    return assignees.some((assignee) => idsEqual(assignee?._id, userId));
  }
  if (MENTIONS_REVISION_TYPES.includes(event.type)) {
    const assignees = event.data?.asset?.assignees || [];
    return assignees.some((assignee) => (
      idsEqual(assignee?._id, userId) || idsEqual(assignee?.assigneeId, userId)
    ));
  }
  return false;
}
